<template>
  <aside>
    <div
      class="hidden md:flex p-6 text-2xl font-bold text-blue-600 justify-between items-center"
    >
      Admin Panel
    </div>
    <div
      class="flex md:hidden pt-10 pb-5 px-5 text-2xl font-bold items-center justify-between"
    >
      <router-link
        to="/portal/account/profile"
        class="flex gap-4 items-center"
        @click="$emit('toggle-sidebar')"
      >
        <img
          class="w-14 h-14 object-cover rounded-full"
          :src="getProfileAvatar"
          alt="Profile"
        />
        <div class="leading-8 flex flex-col">
          <span class="text-primarydark text-xl">{{
            $store.state.userLogged
          }}</span>
          <span class="text-zinc-400 text-sm font-normal">{{
            $store.state.userControlNumber
          }}</span>
          <div>
            <span
              :class="[
                'inline-block px-3 py-1 text-sm font-medium rounded-full',
                $store.state.userMembershipStatus === 'Active'
                  ? 'text-green-700 bg-green-100'
                  : 'text-red-700 bg-red-100',
              ]"
            >
              {{ $store.state.userMembershipStatus }}
            </span>
          </div>
        </div>
      </router-link>

      <div @click="$emit('toggle-sidebar')">
        <ChevronSVG />
      </div>
    </div>
    <div class="my-4 mx-2">
      <ul class="px-2 space-y-3 text-sm">
        <li v-for="(item, index) in itemMenu" :key="index">
          <router-link
            :to="item.path"
            @click="$emit('toggle-sidebar')"
            class="text-zinc-500 font-medium py-2 px-1.5 flex gap-2 items-center hover:bg-orange-100 hover:text-zinc-800 rounded-md"
          >
            <component :is="item.icon" class="h-6 w-6" />
            {{ item.name }}
            <span
              v-if="item.name === 'Electronic Files'"
              class="text-[10px] font-semibold uppercase bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 px-2 py-1 rounded-full shadow-sm tracking-wide"
            >
              Soon
            </span>
          </router-link>
        </li>
        <li @click="handleLogout()">
          <div
            class="text-zinc-500 font-medium py-2 px-1.5 flex gap-2 items-center hover:bg-orange-100 hover:text-zinc-800 rounded-md"
          >
            <LogoutSVG />
            Logout
          </div>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
import ChevronSVG from "@/components/svgs/ChevronRight.vue";
import LogoutSVG from "@/components/svgs/LogoutSvg.vue";
import PrescriptionSVG from "@/components/svgs/PrescriptionSvg.vue";
import AccountSVG from "@/components/svgs/AccountSvg.vue";
import BookSVG from "@/components/svgs/BookSvg.vue";
import HelpSVG from "@/components/svgs/HelpSvg.vue";
import { computed, inject, ref } from "vue";
export default {
  components: {
    ChevronSVG,
    LogoutSVG,
  },
  setup() {
    const axios = inject("$axios");
    const router = inject("$router");
    const profileImageUrl = ref(null);
    const itemMenu = ref([
      {
        id: 1,
        name: "Electronic Files",
        icon: PrescriptionSVG,
        path: "#",
      },
      {
        id: 2,
        name: "Account Setting",
        icon: AccountSVG,
        path: "/portal/account/setting",
      },
      /*
      {
        id: 3,
        name: "User Guidelines",
        icon: BookSVG,
        path: "/portal/account/setting",
      },*/
      {
        id: 4,
        name: "System About",
        icon: HelpSVG,
        path: "/portal/account/setting/about",
      },
    ]);
    const getProfileAvatar = computed(() => {
      return localStorage.getItem("patientProfile");
    });
    const handleLogout = async () => {
      try {
        await axios.post(`/api/patient/signout`);
        router.push("/");
      } catch (error) {
        console.error("Sign-out error:", error);
      }
    };

    return {
      itemMenu,
      profileImageUrl,
      getProfileAvatar,
      handleLogout,
    };
  },
};
</script>
